import customerManagementReducer from "./customerManagementReducer";
import customerRawMaterialReducer from "./customerRawMaterialReducer";

const customerManagementReducers = {
    customerManagement: customerManagementReducer,
    customerRawMaterial: customerRawMaterialReducer,
}

export default customerManagementReducers;